export const DiaperOfferData = [
  {
    id: '1',
    offerName: 'Buy 2 Get 1 FREE',
    perDiaperPrice: '(₹466/diaper)',
    price: '₹1,398',
    strikePrice: '₹2097',
    discount: '42% Off',
    limitedDeal: 'Limited Time Offer',
    isLimitedDeal: true,
  },
  {
    id: '2',
    offerName: 'Buy only 1 Diaper',
    perDiaperPrice: '(₹699/diaper)',
    price: '₹699',
    // strikePrice: "₹699",
    discount: '14% Off',
    limitedDeal: '',
    isLimitedDeal: false,
  },
];
